export default __webpack_public_path__ + "362088ec358d49a99dbea6f4d452b4df.png";